import {MultiSelect} from 'primereact/multiselect'
import {forwardRef, useImperativeHandle, useState} from 'react'
import TranslateUtils from '../../i18n/TranslateUtils'
import FlexBox from '../layout/FlexBox'
import {convertKeyToLabel} from '../table-utils/TableUtils'

const MultiSelectUtils = forwardRef(
    (
        {
            className = '',
            options = [],
            placeholder = '',
            pathway = false,
            maxSelectedLabels = 3,
            callBack = () => {},
            defaultValue = [],
            customDetail = false,
            disabled = false,
            inputId = '',
            required = '',
        },
        ref,
    ) => {
        const {translateCommons} = TranslateUtils()
        useImperativeHandle(ref, () => ({
            value: handleSelectedData(),
            onChangeValue: handleSetSelected,
            clearValue: () => handleClearValue(),
        }))
        const [selected, setSelected] = useState(
            defaultValue ? defaultValue : [],
        )
        const {translateKeys} = TranslateUtils()
        const handleSelectedData = () => {
            return selected
        }

        const handleClearValue = () => {
            setSelected([])

            if (callBack) {
                callBack([])
            }
        }

        const handleSetSelected = value => {
            setSelected(value)

            if (callBack) {
                callBack(value)
            }
        }

        const renderPathwayOption = rowData => {
            return (
                <FlexBox className="col-12">
                    <img
                        className="mr-2"
                        src={rowData.data}
                        height={24}
                        width={28}
                        alt={rowData.label}
                    />
                    <div> {translateKeys(rowData.label)}</div>
                </FlexBox>
            )
        }

        return (
            <span
                className={`${
                    customDetail ? 'p-float-label' : ''
                } col-12 px-0`}>
                <MultiSelect
                    className={`col-12 p-inputtext p-0 ${
                        customDetail ? 'custom-detail' : ''
                    } ${className}`}
                    value={selected || null}
                    disabled={disabled}
                    defaultValue={defaultValue ? defaultValue : null}
                    options={options}
                    onChange={e => handleSetSelected(e.value)}
                    optionLabel="label"
                    optionValue="value"
                    placeholder={`${placeholder}`}
                    itemTemplate={pathway ? renderPathwayOption : ''}
                    maxSelectedLabels={maxSelectedLabels}
                    emptyFilterMessage={translateCommons('No results found')}
                    resetFilterOnHide
                    display="chip"
                    filter
                    filterBy="label"
                    filterPlaceholder={translateCommons('Search here')}
                    style={{
                        '--inputColor': 'rgba(68, 184, 166, 0.1)',
                    }}
                />
                {customDetail && (
                    <label className="ml-2" htmlFor={inputId}>
                        {' '}
                        {translateKeys(convertKeyToLabel(inputId))}
                    </label>
                )}
            </span>
        )
    },
)

export default MultiSelectUtils
